/* Dependencies
 ----------------------------------------------------------*/
 import {Application} from "wrapper6";

 /* Vendor
  ----------------------------------------------------------*/
 import 'promise-polyfill/src/polyfill';
 
 /* Setup
  ----------------------------------------------------------*/
 var app = window.app = new Application(window.options || {});
 
 /* Services
  ----------------------------------------------------------*/
 
 
 /* Register services
  ----------------------------------------------------------*/
 
  
 /* Modules
  ----------------------------------------------------------*/
 import ObjectFit from "../modules/_object-fit";
 import BenefitWidget from "../modules/_benefit-widget";
 import ScrollTo from "../modules/_scrollto";
 import TopMenu from "../modules/_top-menu";
 import FeatureClickables from "../modules/_feature-clickables";
 import Scrollmenu from "../modules/_scrollmenu";
 import FindPerson from "../modules/_find-person";
 import openPositionFilter from "../modules/_open-position-filter";
 import FilterPosts from "../modules/_filter-posts";
 import ClickGallery from "../modules/_click-gallery";
 import VideoModal from "../modules/_video-modal";
 import Navigation from "../modules/_navigation";
 import NewsEventsFilter from "../modules/_news-events";
 import CoverSlider from "../modules/_cover-slider";
 import LazyImages from "../modules/_lazy-images";
 import CountryCodeChecker from "../modules/_country-code-checker";
 import ContactMap from "../modules/_contact-map";
 import Modal from "../modules/_modal";
 import RentalModal from "../modules/_rental-modal";
 import ContactDisplay from "../modules/_contact-display-slider";
 import MorningcatchButton from "../modules/_morningcatch-button";
 import GatedDownloads from "../modules/_gated-downloads";
import timeline from "../modules/_timeline";
import contactPersons from "../modules/_contact-persons";
  
  /* Register modules
  ----------------------------------------------------------*/
  app.use(ObjectFit);
  app.use(BenefitWidget);
  app.use(ScrollTo);
  app.use(TopMenu);
  app.use(FeatureClickables);
  app.use(Scrollmenu);
  app.use(FindPerson);
  app.use(openPositionFilter);
  app.use(FilterPosts);
  app.use(ClickGallery);
  app.use(VideoModal);
  app.use(Navigation);
  app.use(NewsEventsFilter);
  app.use(CoverSlider);
  app.use(LazyImages);
  app.use(CountryCodeChecker);
  app.use(ContactMap);
  app.use(Modal);
  app.use(RentalModal);
  app.use(ContactDisplay);
  app.use(MorningcatchButton);
  GatedDownloads();
  timeline();
  contactPersons();
